import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
import { BillSchema } from '../base/bill.js';
// hoisted so the `satisfies ApiSchema` contextual type (AnyZodObject) can't
// poison the .merge() inference and collapse the body shape to an index signature
const UpdateBillBodySchema = BillSchema.pick({ total: true }).merge(z.object({ updatedDate: z.string().datetime() }));
export const UpdateBillApiSchema = {
    body: UpdateBillBodySchema,
    params: z.object({
        entityId: CornSchema,
        billId: z.string(),
    }),
    headers: z.object({ requestActor: z.string() }),
    response: BillSchema.optional(),
};
export const UpdateBillPathSchema = UpdateBillApiSchema.params;
export const UpdateBillHeadersSchema = UpdateBillApiSchema.headers;
export const UpdateBillRequestSchema = UpdateBillApiSchema.body
    .merge(UpdateBillHeadersSchema)
    .merge(UpdateBillPathSchema);
export const UpdateBillInternalRequestSchema = UpdateBillRequestSchema;
export const UpdateBillResponseSchema = UpdateBillApiSchema.response;
